import { Component, EventEmitter, Inject, Input, OnInit, Output } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import storageService from "@shared/storage/storageService";

export interface DialogData {
  event: boolean;
  title: string;
  message: string;
  tempdata: any;
}

@Component({
  selector: 'app-confirmation-calendar-sync',
  templateUrl: './confirmation-calendar-sync.component.html',
  styleUrls: ['./confirmation-calendar-sync.component.scss']
})
export class ConfirmationCalendarSyncComponent implements OnInit {
  dialogData: DialogData;
  currentUser: any;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationCalendarSyncComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.currentUser = storageService.getItemAsJSON("currentUser");
  }

  cancel(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
    if(this.currentUser) {
      if(this.currentUser.roles[0].name === 'Accountant') {
        this.router.navigate(['accountant/profile']);
      } else {
        this.router.navigate(['chiefaccountant/profile']);
      }
    }
  }

}
